import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MenuItem from "@mui/material/MenuItem";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import FormikActions from "../../commons/formik/formikActions";
import FormikSelect from "../../commons/formik/formikSelect";
import FormikTextField from "../../commons/formik/formikTextField";
import CustomDialog from "./customDialog";

const buildValidation = (addingNew) => Yup.object({
  idArt: addingNew ? Yup.number().required("Campo obligatorio") : Yup.number().nullable(),
  cuit: Yup.string().required("Campo obligatorio"),
  razonSocial: Yup.string().required("Campo obligatorio"),
  nombreFantasia: Yup.string().required("Campo obligatorio"),
  fax: Yup.string().required("Campo obligatorio"),
  codigoPrestadorArt: Yup.number().positive("El código debe ser un número positivo").nullable().transform((value, originalValue) => (originalValue === "" ? null : value)),
});

const EditDatacenterPrestadorDialog = ({
  prestador,
  arts,
  open,
  handleClose,
  addingNewProvider,
  isSubmitting,
  handleSubmit,
}) => {
  const editTitle = prestador.artNombre ? `Editar Prestador - ${prestador.artNombre}` : "Editar Prestador";

  const initialValues = {
    idArt: prestador.idArt || "",
    cuit: prestador.cuit || "",
    razonSocial: prestador.razonSocial || "",
    nombreFantasia: prestador.nombreFantasia || "",
    mail: prestador.mail || "",
    calle: prestador.calle || "",
    numero: prestador.numero || "",
    codigoPostal: prestador.codigoPostal || "",
    provincia: prestador.provincia || "",
    telefono: prestador.telefono || "",
    fax: prestador.fax || "",
    codigoPrestadorArt: prestador.codigoPrestadorArt || "",
  };

  return (
    <CustomDialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>{addingNewProvider ? "Agregar Prestador" : editTitle}</DialogTitle>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={buildValidation(addingNewProvider)}
        onSubmit={(values) => handleSubmit(values, addingNewProvider)}>
        {() => (
          <Form>
            <DialogContent>
              <FormikSelect
                margin="dense"
                id="idArt"
                name="idArt"
                label="ART"
                fullWidth
                disabled={!addingNewProvider}
              >
                <MenuItem value="">Seleccionar...</MenuItem>
                {arts.map((art) => (
                  <MenuItem key={art.id} value={art.id}>
                    {art.nombre}
                  </MenuItem>
                ))}
              </FormikSelect>

              <FormikTextField margin="dense" id="cuit" name="cuit" label="CUIT" type="text" variant="standard" fullWidth />

              <FormikTextField margin="dense" id="razonSocial" name="razonSocial" label="Razón Social" type="text" variant="standard" fullWidth />

              <FormikTextField margin="dense" id="nombreFantasia" name="nombreFantasia" label="Nombre de Fantasía" type="text" variant="standard" fullWidth />

              <FormikTextField margin="dense" id="mail" name="mail" label="Mail" type="email" variant="standard" fullWidth />

              <FormikTextField margin="dense" id="calle" name="calle" label="Calle" type="text" variant="standard" fullWidth />

              <FormikTextField margin="dense" id="numero" name="numero" label="Número" type="number" variant="standard" fullWidth />

              <FormikTextField margin="dense" id="codigoPostal" name="codigoPostal" label="Código Postal" type="text" variant="standard" fullWidth />

              <FormikTextField margin="dense" id="provincia" name="provincia" label="Provincia" type="text" variant="standard" fullWidth />

              <FormikTextField margin="dense" id="telefono" name="telefono" label="Teléfono" type="text" variant="standard" fullWidth />

              <FormikSelect margin="dense" id="fax" name="fax" label="Tipo de Conexión" fullWidth>
                <MenuItem value="">Seleccionar...</MenuItem>
                <MenuItem value="Connect">Connect</MenuItem>
                <MenuItem value="ML.point">ML.point</MenuItem>
                <MenuItem value="ML-Connect">ML-Connect</MenuItem>
              </FormikSelect>
              <FormikTextField margin="dense" id="codigoPrestadorArt" name="codigoPrestadorArt" label="Código Prestador ART" type="number" fullWidth />
            </DialogContent>
            <DialogActions>
              <FormikActions handleCancel={handleClose} disabled={isSubmitting} submitText={isSubmitting ? "Enviando..." : "Aceptar"} />
            </DialogActions>
          </Form>
        )}
      </Formik>
    </CustomDialog>
  );
};

export default EditDatacenterPrestadorDialog;